// core
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

// raptor
import { RAPTOR_DEBOUNCE_TIME } from '../../constant/raptor-constants';
import { RaptorControlService } from '../../services/raptor-control.service';

@Component({
  selector: 'open-raptor-question-error',
  templateUrl: './raptor-question-error.component.html',
  styleUrls: ['./raptor-question-error.component.scss']
})
export class RaptorQuestionErrorComponent implements OnInit, OnDestroy {
  @Input() question!: any;
  @Input() form!: FormGroup;
  @Input() submitted!: Boolean;

  questionControl: any;
  questionValueWatcher!: Subscription;

  constructor(private raptorControlService: RaptorControlService) { }

  ngOnInit(): void {
    if (this.question) {
      this.questionControl = this.form.get(this.question.key);

      if (this.question.error) {
        setTimeout(() => {
          this.setPageError(this.question.error);
        }, RAPTOR_DEBOUNCE_TIME);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.questionValueWatcher) {
      this.questionValueWatcher.unsubscribe();
    }
  }

  setPageError(error: string) {
    let validatorArray: Array<any> = [];
    const validator = function customValidator(control: any) {
      return { pageError: error };
    }
    validatorArray.push(validator);
    this.questionControl.setValidators(validatorArray);
    this.questionControl.updateValueAndValidity();
    this.questionValueWatcher = this.questionControl.valueChanges
      .pipe(
        distinctUntilChanged((previous, current) => {
          return !this.raptorControlService.formValueChanged(previous, current);
        })
      )
      .subscribe((newSelectedValues: any) => {
        this.questionControl.removeValidators(validator);
        this.questionControl.updateValueAndValidity();
        this.questionValueWatcher.unsubscribe();
      });
  }

  get fieldErrors() {
    return this.questionControl && this.questionControl.errors;
  }
}
